import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { Note } from '@interfaces';
import { StaticDataService } from '../../../../services';
import { BaseService } from '../notes.part';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(parent: 'person' | 'acc-venture', util: UtilityService, service: BaseService, dialog: DialogService, staticData: StaticDataService, openNotesDialog: (note?: Note) => Promise<void>): GridSetup<Note> {

	return {
		rowName: { singular: 'Note', plural: 'Notes' },
		getRowKey: row => '' + row.noteId,
		stateKey: `${parent}-explorer-notes-grid`,
		actions: getActions(dialog, service, openNotesDialog),
		buttons: getButtons(openNotesDialog),
		columns: getColumns(util, staticData),
	}
}
